import React from "react";
import Slider from "react-slick";
import { ChevronRight, ChevronLeft } from "lucide-react";
import "../styles/Hero.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NextArrow = (props: any) => (
  <button
    {...props}
    className={`slick-arrow slick-next ${props.className || ""}`}
    style={{ ...props.style }}
    aria-label="Next Slide"
    type="button"
  >
    <ChevronRight size={24} strokeWidth={2} />
  </button>
);

const PrevArrow = (props: any) => (
  <button
    {...props}
    className={`slick-arrow slick-prev ${props.className || ""}`}
    style={{ ...props.style }}
    aria-label="Previous Slide"
    type="button"
  >
    <ChevronLeft size={24} strokeWidth={2} />
  </button>
);

const Hero: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    pauseOnHover: false,
    swipeToSlide: true,
    touchThreshold: 10,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: true,
          autoplaySpeed: 4000,
          pauseOnHover: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          dots: true,
          autoplaySpeed: 5000,
          pauseOnHover: false,
        },
      },
    ],
  };

  const slides = [
    "/images/1.webp",
    "/images/2.webp",
    "/images/3.webp",
    "/images/4.webp",
    "/images/parw.png",
  ];

  return (
    <section id="home" className="hero-carousel-section">
      <Slider {...settings}>
        {slides.map((src, index) => (
          <div key={index} className="hero-slide">
            <img
              src={src}
              alt={`Slide ${index + 1}`}
              className={`hero-slide-image ${src.includes("parw.png") ? 'parwah-logo-image' : ''}`}
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Hero;
